

const TRANSLATIONS_FI_FI = {
    "email_otp.back":"Takaisin",
    "email_otp.enter_email_text":"Anna sähköpostiosoitteesi alla, niin sinulle lähetetään yksilöllinen koodi",
    "email_otp.send_verification_link":"Lähetä vahvistuskoodi",
    "email_otp.resend_otp_with_timer":"Lähetä kertakäyttöinen salasana uudelleen",
    "email_otp.text":"Olemme lähettäneet kuusinumeroisen vahvistuskoodin osoitteeseen [email]. Lisää koodi alle",
    "email_otp.verify":"Vahvista",
    "reset_password.set_password":"Nollaa salasana",
    "sign_in.or":"tai",
    "sign_in.continue_with":"Tai jatka seuraavilla",
    "sign_in.continue_with_email":"Tai jatka sähköpostilla",
    "sign_in.create_without_password":"Luo tili ilman salasanaa",
    "sign_in.create_with_otp":"Luo tili kertakäyttöisellä koodilla",
    "sign_in.login_with_otp":"Kirjaudu sisään kertakäyttöisellä koodilla",
    "sign_in.login_without_password":"Kirjaudu sisään ilman salasanaa",
    "sign_in.tooltip_text":"Saat sähköpostitse väliaikaisen yksilöllisen vahvistuskoodin, jolla pääset tilillesi.",
    "sign_up.tooltip_text":"Saat sähköpostitse väliaikaisen yksilöllisen vahvistuskoodin tilin luomista varten.",
    "sign_in.password_updated":"Salasanasi on päivitetty.",
    "sign_up.create_an_account":"Luo tili",
    "email_otp.resend_otp":"Lähetä kertakäyttöinen salasana uudelleen",
    "sign_up.email_address":"Sähköpostiosoite",
    "sign_up.password":"Salasana",
    "sign_in.create_account" : "Luo tili",
    "sign_in.title": "Kirjaudu Sisään",
    "sign_in.forgot_password" : "Unohditko salasanasi?",
    "reset_password.resend_email": "Lähetä sähköposti uudestaan",
    "reset_password.sent_title": "Sähköposti on lähetetty!",
    "reset_password.rcvResetLink": "Kirjoita sähköpostiosoitteesi alle ja lähetämme sinulle salasanan palautuslinkin.",
    "reset_password.submit": "Lähetä",
    "reset_password.back_to_login": "Takaisin sisäänkirjautumiseen",
    "reset_password.create_new_password": "Luo uusi salasana, jotta voit kirjautua tilillesi.",
    "forgot_password.emailSent": "Jos [] -osoitteelle on jo tili, osoitteeseen lähetetään sähköpostiviesti ja linkki salasanan vaihtamista varten. Eikö viestiä löydy? Pyydä uutta sähköpostiviestiä alta.",
    "gdpr.continue": "Jatka",
    "validation.password_validation_heading": "Salasanassa täytyy olla:",
    "validation.password_length_ui": "Vähintään 8 merkkiä",
    "validation.password_upper_case_ui": "Iso kirjain",
    "validation.password_lower_case_ui": "Pieni kirjain",
    "validation.password_number_ui": "Numero",
    "validation.password_symbol_ui": "Erikoismerkki",
    "verify_otp.customer_service_center_link": "s/asiakaspalvelu",
    "activate_user.verification_successful.message": "Onnittelut! Tilisi on aktivoitu.",
    "activate_user.already_verified.message" : "Tervetuloa takaisin! Tilisi on jo vahvistettu.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Täytä kaikki pakolliset kentät ennen kuin jatkat.",
    "sign_in.invalid_email_error": "Anna sähköpostiosoite oikeassa muodossa, esim. nimi@toimialue.com",
    "sign_in.invalid_credentials_error": "Olet antanut virheellisen käyttäjätunnuksen tai salasanan. Yritä uudelleen.",
    "sign_in.generic_error": "Jokin meni vikaan. Yritä uudelleen.",
    "sign_in.account_unverified_error": "Tiliäsi ei ole vielä aktivoitu. Etsi aktivointilinkki sähköpostistasi tai napsauta ”Unohditko salasanan?” palauttaaksesi pääsyn tilille.",
    "sign_in.max_attempt_error": "Kirjautumisyritysten enimmäismäärä saavutettu. Kokeile myöhemmin uudelleen.",
    "sign_in.social_signin_error": "Sosiaalisen median (Google/Facebook/Apple) kautta kirjautuminen epäonnistui. Yritä uudelleen tai kokeile toista kirjautumistapaa",
    "sign_in.social_signin_email_not_present_error": "Kirjautuminen epäonnistui. Yritä uudelleen tai kokeile toista kirjautumistapaa.",
    "sign_in.guest_user_signin_error": "Sinulla näyttää olevan jo tili tällä sähköpostiosoitteella. Klikkaa Unohditko salasanasi? palauttaaksesi kirjautumistietosi.",

    "sign_up.mandatory_field_error": "Täytä kaikki pakolliset kentät ennen kuin jatkat.",
    "sign_up.invalid_email_error": "Anna kelvollinen sähköpostiosoite, esim. nimi@toimialue.com",
    "sign_up.password_length_error": "Salasanassa täytyy olla vähintään 8 merkkiä.",
    "sign_up.email_already_exist_error": "Tämä sähköpostiosoite on jo käytössä. Anna toinen sähköpostiosoite.",
    "sign_up.generic_error": "Jokin meni vikaan. Yritä uudelleen.",
    "sign_up.password_policy_error": "Salasanassa täytyy olla: numero, erikoismerkki [!#$%&'*+-/=?^_`{|}~.@] ja sekä isoja että pieniä kirjaimia.",
    "sign_up.common_password_error": "Salasana ei voi olla sama kuin sähköpostiosoitteesi",

    "forgot_password.mandatory_field_error": "Täytä kaikki pakolliset kentät ennen kuin jatkat.",
    "forgot_password.invalid_email_error": "Anna sähköpostiosoite oikeassa muodossa, esim. nimi@toimialue.com",
    "forgot_password.generic_error": "Jokin meni vikaan. Yritä uudelleen.",

    "reset_password.mandatory_field_error": "Täytä kaikki pakolliset kentät ennen kuin jatkat.",
    "reset_password.password_history_error": "Valitse eri salasana kuin viisi aiempaa salasanaa.",
    "reset_password.password_length_error": "Salasanassa täytyy olla vähintään 8 merkkiä.",
    "reset_password.password_policy_error": "Salasanassa täytyy olla: numero, erikoismerkki [!#$%&'*+-/=?^_`{|}~.@] ja sekä isoja että pieniä kirjaimia.",
    "reset_password.common_password_error": "Salasana ei voi olla sama kuin sähköpostiosoitteesi",
    "reset_password.generic_error": "Jokin meni vikaan. Yritä uudelleen.",

    "email_otp.email_required_error": "Jatka antamalla sähköpostiosoitteesi",
    "email_otp.invalid_email_error": "Anna kelvollinen sähköpostiosoite, esim. nimi@toimialue.com",
    "email_otp.generic_error": "Jokin meni vikaan. Kokeile myöhemmin uudelleen",
    "email_otp.invalid_otp_error": "Antamasi kertakäyttöinen salasana tai vahvistuskoodi ei kelpaa. Yritä uudelleen.",
    "email_otp.resend_otp_error": "Kertakäyttöisen salasanan lähettäminen ei onnistu. Kokeile myöhemmin uudelleen",
    "email_otp.verify_otp_error": "Jokin meni vikaan. Kokeile kertakäyttöisen salasanan avulla vahvistusta myöhemmin",
    "email_otp.verify_otp_limit_exceed_error": "Annettu kertakäyttöinen salasana ei kelpaa. Napsauta ”Lähetä uusi kertakäyttöinen salasana”",
    "email_otp.max_attempt_reached_error": "Kirjautumisyritysten enimmäismäärä saavutettu. Kokeile myöhemmin uudelleen.",
    "email_otp.brute_force_error_part_1": "Tilisi on lukittu väliaikaisesti usean epäonnistuneen kirjautumisyrityksen takia. Kokeile myöhemmin uudelleen tai ",
    "email_otp.brute_force_error_part_2": "ota yhteyttä ohjekeskukseen",
    "email_otp.brute_force_error_part_3": ".",
    "form.gdprconsent": "Kirjautumalla sisään vahvistat lukeneesi ja hyväksyväsi",
    "form.termsCondition": "käyttöehtomme",

    //Page Titles
    "sign_in.page_title": "Kirjaudu sisään | Pens.com",
    "sign_up.page_title": "Rekisteröidy | Pens.com",
    "forgot-password.page_title": "Unohditko salasanasi | Pens.com",
    "reset-password.page_title": "Vahvista salasana | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_FI_FI;